import React from 'react';
import { motion } from 'framer-motion';

const ConfettiEffect: React.FC = () => {
  const confettiPieces = Array.from({ length: 50 }, (_, i) => i);
  const colors = ['#9333ea', '#3b82f6', '#ec4899', '#10b981', '#f59e0b'];

  return (
    <div className="absolute inset-0 pointer-events-none z-50 overflow-hidden">
      {confettiPieces.map((i) => (
        <motion.div
          key={i}
          className="absolute w-2 h-2 rounded-sm"
          style={{
            backgroundColor: colors[Math.floor(Math.random() * colors.length)],
            left: `${Math.random() * 100}%`,
            top: '-10%'
          }}
          initial={{ 
            y: 0, 
            rotate: 0,
            opacity: 1
          }}
          animate={{ 
            y: '120vh',
            rotate: Math.random() * 720 - 360,
            opacity: 0,
            x: [(Math.random() - 0.5) * 100, (Math.random() - 0.5) * 200]
          }}
          transition={{ 
            duration: Math.random() * 2 + 2,
            ease: "easeIn",
            delay: Math.random() * 0.5
          }}
        />
      ))}
    </div>
  );
};

export default ConfettiEffect;
